"use strict";

var _interopRequireDefault = require("/www/wwwroot/node/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.regexp.split");
var _defineProperty2 = _interopRequireDefault(require("/www/wwwroot/node/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _request = _interopRequireDefault(require("@/utils/request"));
var _RestTable = _interopRequireDefault(require("@/components/RestTable.vue"));
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _vuex = require("vuex");
var _formatMixin = require("@/utils/formatMixin");
var _encrypt = require("@/utils/encrypt");
var _user = require("@/api/user");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports.default = {
  components: {
    RestTable: _RestTable.default,
    Pagination: _index.default
  },
  mixins: [_formatMixin.formatMixin],
  data: function data() {
    return {
      config: {},
      depositDialog: false,
      setdepositDialog: false,
      moneyList: {
        count: 0
      },
      // 划扣流水
      listQuery: {
        page: 1,
        page_size: 10
      },
      listLoading: false,
      lastExecutedTime: 0,
      // 上次执行的时间
      user_money: 0,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      dialogFormVisible4: false,
      bank_no: '',
      pk: 0,
      money: 0,
      get_money: 0,
      isSubmitting: false // 新增标志变量
    };
  },
  created: function created() {
    this.getMoneyList();
    this.getConfigList();
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['name', 'perms'])), {}, {
    lines: function lines() {
      return this.config.value.split(/[；;]/).map(function (i) {
        return i.trim();
      }).filter(Boolean);
    },
    // isAdmin
    // 如果perms包含 admin 字段 即为管理员，则返回true  否则为false
    isAdmin: function isAdmin() {
      return this.perms.includes('admin');
    },
    is_withdrawal: function is_withdrawal() {
      return this.perms.includes('withdrawal_ok');
    }
  }),
  methods: {
    getConfigList: function getConfigList() {
      var _this = this;
      (0, _user.getConfigList)({
        group: 'without',
        ttype: 'jd'
      }).then(function (response) {
        if (response.data) {
          _this.config = response.data[0];
        }
      });
    },
    clossPop5: function clossPop5() {
      var _this2 = this;
      (0, _user.updateConfig)(this.config.id, this.config).then(function (res) {
        _this2.getConfigList();
        _this2.setdepositDialog = false;
        _this2.$message({
          message: "编辑成功",
          type: "success"
        });
      });
    },
    // 获取提现明细——done
    getMoneyList: function getMoneyList() {
      var _this3 = this;
      this.listLoading = true;
      // 王工封装
      // type 2 为支付宝账号流水
      (0, _request.default)({
        url: "/system/order/getUserRecord/",
        method: 'put',
        data: {
          shop_id: this.$user.data.shop,
          type: 2,
          remark: 'JD余额提现',
          page: this.listQuery.page,
          page_size: this.listQuery.page_size,
          is_pay: -1
        }
      }).then(function (response) {
        if (response.data) {
          _this3.moneyList = response.data.data;
          _this3.user_money = response.data.data.jd_money;
        }
        _this3.listLoading = false;
      });
    },
    // 确认打款，加限制——done
    approve: function approve(value) {
      this.dialogFormVisible = true;
      this.pk = value.pk;
    },
    withMoneyOnly: function withMoneyOnly(value) {
      var _this4 = this;
      this.$confirm('确认已线下转账金额' + value.money + '?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 发请求提交数据给后端
        (0, _request.default)({
          url: "/system/user/JdwithMoneyOnly/",
          method: 'put',
          data: {
            record_id: value.pk
          }
        }).then(function (response) {
          if (response.code == 200) {
            _this4.$message({
              message: '提现成功',
              type: 'success'
            });
            _this4.getMoneyList(); // 刷新列表
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消提现'
        });
      });
    },
    withMoney: function withMoney(value) {
      var _this5 = this;
      this.$confirm('确认提现金额' + value.money + '元到平台余额?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 发请求提交数据给后端
        (0, _request.default)({
          url: "/system/user/JdwithMoney/",
          method: 'put',
          data: {
            record_id: value.pk
          }
        }).then(function (response) {
          if (response.code == 200) {
            _this5.$message({
              message: '提现成功',
              type: 'success'
            });
            _this5.getMoneyList(); // 刷新列表
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function () {
        _this5.$message({
          type: 'info',
          message: '已取消提现'
        });
      });
    },
    // 商家提现确认的请求
    clossPop3: function clossPop3() {
      var _this6 = this;
      var currentTime = Date.now();
      if (currentTime - this.lastExecutedTime > 2000 && !this.isSubmitting) {
        this.isSubmitting = true; // 设置为正在提交
        (0, _request.default)({
          url: "/system/user/JdWithdrawalApplication/",
          method: 'put',
          data: {
            money: this.get_money,
            bank_no: this.bank_no,
            shop_id: this.$user.data.shop
          }
        }).then(function (response) {
          if (response.code == 200) {
            _this6.dialogFormVisible3 = false;
            _this6.get_money = 0;
            _this6.getMoneyList(); // 刷新列表
            // 提示
            _this6.$message.success('提交成功');
          }
          _this6.isSubmitting = false; // 请求成功后重置
        }).catch(function (error) {
          _this6.dialogFormVisible3 = false;
          _this6.isSubmitting = false; // 请求成功后重置
        });
      } else {
        this.$message.error('请勿频繁操作');
        this.lastExecutedTime = currentTime;
        this.dialogFormVisible3 = false;
      }
    },
    deleteRow: function deleteRow(value) {
      var _this7 = this;
      this.$confirm('确认删除当前提现记录?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 发请求提交数据给后端
        (0, _request.default)({
          url: "/system/order/JduserRecordDel/",
          method: 'delete',
          data: {
            record_id: value.pk
          }
        }).then(function (response) {
          if (response.code == 200) {
            _this7.$message({
              message: '删除成功',
              type: 'success'
            });
            _this7.getMoneyList(); // 刷新列表
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function () {
        _this7.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    addMoney: function addMoney() {
      this.dialogFormVisible2 = true;
    },
    getMoney: function getMoney() {
      //申请提现
      this.dialogFormVisible3 = true;

      // this.dialogFormVisible3=true
    },
    setUserAlipay: function setUserAlipay() {
      //申请提现
      this.dialogFormVisible4 = true;

      // this.dialogFormVisible3=true
    }
  }
};